import styled from "styled-components/macro";

export const Cluster = styled.div`
  display: flex;
  gap: var(--space, 1rem);
  align-items: flex-start;
`;
